import { useTranslation } from 'react-i18next';
import { MarketDetails, CountryOption } from '../../types';
import { Typography } from '@/components';
import { MarketListItems } from './market-list-items';

type MarketsDetailsProps = {
  readonly markets: MarketDetails[];
  readonly countries: CountryOption[];
};

export function MarketsDetails({ markets, countries }: MarketsDetailsProps) {
  const { t } = useTranslation(['insights']);
  return (
    <>
      <Typography as="h1" size="heading-2" weight="semibold" className="mb-2">
        {t('Market Prices')}
      </Typography>
      <Typography as="p" size="body-2" color="secondary" weight="normal">
        {t(
          'In this section, you will find the latest pricing data and transaction trends for renewable energy projects and assets.'
        )}
      </Typography>

      <div className="mt-5 space-y-3">
        <MarketListItems markets={markets} countries={countries} />
      </div>
    </>
  );
}
